import { memo, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  children?: ReactNode
  className?: string
  height?: number
  isLoading?: boolean
  seed?: number
}

export const PlaceholderCell = memo(function PlaceholderCell({ className, seed, children, height = 16 }: IProps) {
  return (
    <div
      style={{ height }}
      className={cn('block w-full min-w-[24px] animate-blink-bg rounded-[3px] bg-on-surface/[.06]', className, {
        'max-w-[180px]': seed && seed % 1 === 0,
        'max-w-[220px]': seed && seed % 2 === 0,
        'max-w-[80%]': seed && seed % 2 === 0 && seed % 3 === 0,
        'max-w-[90%]': seed && seed % 3 === 0,
        'max-w-[85%]': seed && seed % 5 === 0,
        'max-w-[420px]': seed && seed % 420 === 0,
        'max-w-[60px]': seed && seed % 60 === 0
      })}
    >
      {children}
    </div>
  )
})
